import { createContext, useContext } from 'react';

/** 'system' 代表不在 documentElement 上蓋 data-theme，交給 prefers-color-scheme。 */
export type ThemePreference = 'system' | 'light' | 'dark';

export interface ThemeContextValue {
  theme: ThemePreference;
  setTheme: (theme: ThemePreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (ctx === null) {
    throw new Error('useTheme 必須在 <ThemeProvider> 之內使用。');
  }
  return ctx;
}
